var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#A7ABB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25391 9V4.99219C8.25391 4.66146 8.27344 4.26432 8.3125 3.80078H8.29297C8.22526 4.09245 8.16536 4.29557 8.11328 4.41016L6.11719 9H5.68359L3.69141 4.44531C3.64453 4.34115 3.58464 4.1263 3.51172 3.80078H3.48828C3.51432 4.08203 3.52734 4.49089 3.52734 5.02734V9H2.78125V2.94922H3.83984L5.625 7.09766C5.76042 7.41536 5.85026 7.66276 5.89453 7.83984H5.92188C6.05729 7.46745 6.15234 7.21484 6.20703 7.08203L8.02344 2.94922H9.03125V9H8.25391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.f36babebbeaa9d18cc20d8eae2ddc051.svg";
export { ForwardRef as ReactComponent };